module.exports = __webpack_public_path__ + "static/img/bmb.9d1a91a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bmb.jpg
// module id = WoOI
// module chunks = 1